import { OrderStatus } from '../../types/ordering.types';

const STATUS_CONFIG: Record<OrderStatus, { label: string; cls: string }> = {
  [OrderStatus.Draft]:               { label: 'Draft',                     cls: 'pill-draft' },
  [OrderStatus.Requested]:                { label: 'Pending LM Approval',       cls: 'pill-requested' },
  [OrderStatus.LMApproved]:              { label: 'Pending Approval',          cls: 'pill-lm-approved' },
  [OrderStatus.PendingEscalatedApproval]: { label: 'Pending Extended Approval', cls: 'pill-requested' },
  [OrderStatus.PendingCEOApproval]:  { label: 'Pending CEO Approval',      cls: 'pill-pending-ceo' },
  [OrderStatus.PendingCFOApproval]:  { label: 'Pending CFO Approval',      cls: 'pill-pending-cfo' },
  [OrderStatus.PendingChemApproval]: { label: 'Pending Chemical Approval', cls: 'pill-pending-chem' },
  [OrderStatus.ChemicalApproved]:    { label: 'Approved',                  cls: 'pill-chem-approved' },
  [OrderStatus.OMApproved]:          { label: 'Approved',                  cls: 'pill-om-approved' },
  [OrderStatus.Ordered]:             { label: 'Ordered',                   cls: 'pill-ordered' },
  [OrderStatus.PartialDelivery]:     { label: 'Partial Delivery',          cls: 'pill-partial' },
  [OrderStatus.Delivered]:           { label: 'Delivered',                 cls: 'pill-delivered' },
  [OrderStatus.ForReview]:           { label: 'For Review',                cls: 'pill-for-review' },
  [OrderStatus.Rejected]:            { label: 'Rejected',                  cls: 'pill-rejected' },
  [OrderStatus.Cancelled]:           { label: 'Cancelled',                 cls: 'pill-cancelled' },
};

export function OrderStatusPill({ status }: { status: OrderStatus }) {
  const cfg = STATUS_CONFIG[status] ?? { label: status, cls: 'pill-draft' };
  const wrap = cfg.label.length > 14;
  return (
    <span
      className={`pill ${cfg.cls}`}
      style={wrap ? { whiteSpace: 'normal', textAlign: 'center', lineHeight: 1.3 } : undefined}
    >
      {cfg.label}
    </span>
  );
}
